import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import sicrediColor from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        display: 'flex',
        boxSizing: 'border-box',
        width: '100%',
        padding: theme.spacing(2),
        backgroundColor: sicrediColor.secondarySicrediLightest,
      },
      button: {
        width: '100%',
        padding: '20px 0px',
        border: '1px solid',
        borderRadius: '8px',
        borderColor: sicrediColor.primarySicredi,
        backgroundColor: sicrediColor.primaryColor50,
        transition: '0.3s ease-in-out',
        color: sicrediColor.primarySicredi,

        '& > span': {
          display: 'block',
          marginTop: '-3px',
          fontSize: '16px',
          fontWeight: '700',
        },

        '&:not(:disabled):active': {
          transform: 'scale(0.98)',
        },
        '&:not(:disabled):hover': {
          cursor: 'pointer',
        },
        '&:disabled': {
          borderColor: '#cdd3cd',
          backgroundColor: '#f3f3f3',

          '& > span': {
            color: '#cdd3cd',
          },
        },
      },
      form: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        boxSizing: 'border-box',
        width: '100%',
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: sicrediColor.primarySicredi,
        borderRadius: 10,
        backgroundColor: 'white',
        padding: theme.spacing(0, 1, 0, 2),
      },
      formIsDisabled: {
        borderColor: sicrediColor.secondarySicredi,
      },
      input: {
        flex: 'auto',
      },
      textArea: {
        font: 'inherit',
        color: '#828a82',
        width: '100%',
        border: 0,
        height: '1.1876em',
        margin: 0,
        display: 'block',
        padding: '6px 0 7px',
        minWidth: 0,
        background: 'none',
        boxSizing: 'content-box',
        letterSpacing: 'inherit',
        resize: 'none',
        outline: 'none',
        fontFamily: 'Nunito',
        fontSize: 14,
      },
      counter: {
        display: 'flex',
        color: sicrediColor.secondarySicredi,
        fontFamily: '"Nunito", sans-serif',
        fontSize: 13,
        fontWeight: 300,
        margin: theme.spacing('auto', 1),
      },
      counterMax: {
        display: 'flex',
        fontFamily: '"Nunito", sans-serif',
        fontSize: 13,
        fontWeight: 300,
        margin: theme.spacing('auto', 1),
        color: sicrediColor.dangerSicrediDark,
      },
      submit: {
        fontSize: 16,
        '&.Mui-disabled': {
          color: sicrediColor.secondarySicredi,
        },
      },
    }),
  { name: 'Perguntar' }
);
